/* src/app/fixed-price/containers/fixed-price-shell/fixed-price-shell.component.scss */
/*# sourceMappingURL=fixed-price-shell.component.css.map */
